import { render, staticRenderFns } from "./LadoB.vue?vue&type=template&id=3403dafb"
import script from "./LadoB.vue?vue&type=script&lang=js"
export * from "./LadoB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports